export default function login({
  email,
  password,
  otp_code,
  remember_device,
  remember_device_token,
}: {
  email: string
  password: string
  otp_code?: string
  remember_device?: boolean
  remember_device_token?: string | null
}) {
  return fetch(`${window.graphqlEndpoint}/auth`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      password,
      otp_code,
      remember_device,
      remember_device_token,
    }),
  }).then((response) => response.json())
}
